import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!

  return (_openBlock(), _createBlock(_component_TextField, {
    title: _ctx.$t('equipment-and-inventory'),
    "model-value": _ctx.characters[_ctx.current].inventory,
    "onUpdate:modelValue": _ctx.updateInventory
  }, null, 8, ["title", "model-value", "onUpdate:modelValue"]))
}